<template>
  <div class="share-shortlist">
    <div class="close-btn">
      <button
        type="button"
        class="circled interactive grey close-modal outline"
        @click.stop.prevent="closeShare"
      >
        <svg-icon id="cross"></svg-icon>
      </button>
    </div>

    <div class="share-shortlist-content">
      <div class="share-shortlist-heading">
        Download or share {{ data.shortlist.label }}
      </div>

      <div class="share-pdf-container">
        <loader-button
          @click.native="downloadPdf"
          label="Download PDF"
          class="download"
          :loading="loading"
          after-icon="download"
        ></loader-button>
      </div>
    </div>

    <div class="share-link-container" v-if="data.shortlist.public_url">
      <div class="share-link" @click="copyLink">
        {{ data.shortlist.public_url }}
      </div>
      <div class="share-copy" @click="copyLink">
        <svg xmlns="http://www.w3.org/2000/svg">
          <image xlink:href="/images/icons/copy-link-dark.svg" />
        </svg>
        Copy<span class="tablet-hidden"> Link</span>
      </div>
    </div>
  </div>
</template>

<script>
import BaseModal from '../Base'
import fileDownload from 'js-file-download';

export default {
  extends: BaseModal,
  props: {
    data: {
      type: Object,
      required: true,
    }
  },
  data () {
    return {
      shareLink: null,
      loading: false
    }
  },
  methods: {
    closeShare() {
      this.$emit('cancel');
    },
    copyLink() {
      navigator.clipboard.writeText(this.data.shortlist.public_url)
        .then(() => {
          this.$toasted.show(
            'Successfully copied to clipboard', { type: 'success' }
          )
        });
    },
    downloadPdf() {
      this.$store.dispatch("intercom/track", {
        type: "User downloaded a shortlist",
        meta: {
            label: this.data.shortlist.label,
            agency_name: this.data.shortlist.agency_name,
            brand_name: this.data.shortlist.brand_name
        },
      });
      console.log('Intercom New: User downloaded a shortlist', {label: this.data.shortlist.label, agency_name: this.data.shortlist.agency_name, brand_name: this.data.shortlist.brand_name});

      this.loading = true;
      axios
        .get(`/api/account/shortlists/${this.data.shortlist.id}/export`, {
          responseType: "blob",
        })
        .then((response) => {
          this.loading = false;
          fileDownload(response.data, `${this.data.shortlist.label}.pdf`);
        });
    }
  },
}
</script>
